import { peekActiveCompanyKey } from "utils/encryptForCompany";
import pluginService from "api/pluginService";
import { useAuth } from "react-oidc-context";
import { getKeys } from "utils/getKeys";
import { getUserId } from "utils/getUserId";
import {
  isPluginConnectionStale,
  resolvePluginConnectionKeys,
  setConnectedPluginCompanyKeyIdentity,
  companyKeyIdentity,
} from "utils/pluginConnection";

export function usePlugin() {
  const { mutate: createConnection } = pluginService.useCreateConnection();
  const { mutate: setConnection } = pluginService.useSetConnection();
  const auth = useAuth();
  const userId = getUserId(auth.user!);

  const connect = (): Promise<void> => {
    return new Promise<void>(async (resolve, reject) => {
      if (!auth.isAuthenticated) return;
      const keys = await getKeys(userId);
      if (!keys) return reject();

      // Klucz FIRMY (a nie intermediate) — od F3 wtyczka nim odszyfrowuje UserKey
      // obiektów; szczegóły i to, co zostało, w utils/pluginConnection.ts.
      let PrivateKey: string;
      let PublicKey: string;
      try {
        ({ PrivateKey, PublicKey } = await resolvePluginConnectionKeys(keys));
      } catch {
        // Bez materiału klucza nie ma czego wysłać wtyczce — połączenie się nie uda.
        return reject();
      }

      createConnection(
        {
          AppId: "todo",
          Version: "1.0.0.0",
        },
        {
          onSuccess: (response) => {
            setConnection(
              {
                PrivateKey,
                PublicKey,
                //Token: response.data.Token,
                Token: response.data.AccessToken,
                RefreshToken: response.data.RefreshToken,
                Url: response.data.Url,
              },
              {
                onSuccess: () => {
                  setConnectedPluginCompanyKeyIdentity(
                    companyKeyIdentity(peekActiveCompanyKey()),
                  );
                  resolve();
                },
                onError: () => {
                  reject();
                },
              },
            );
          },
          onError: () => {
            reject();
          },
        },
      );
    });
  };

  return {
    connect,
    // Wtyczka trzyma klucz z ostatniego połączenia — po rotacji generacji klucza firmy
    // albo zmianie firmy trzeba połączyć się ponownie (samo IsConnected tego nie wykryje).
    isConnectionStale: isPluginConnectionStale(peekActiveCompanyKey()),
  };
}

export default usePlugin;
